import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationService } from "../../services/application.service";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-screen-error",
  templateUrl: "./error.html",
  styleUrls: ["./error.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class ErrorComponent {
  readonly applicationService = inject(ApplicationService);
  readonly translateService = inject(TranslateService);

  public constructor() {
    this.applicationService.updateTitle("Oops!");
  }
}
